<script setup lang="ts">
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderBlock
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=22864-46
 */
import { Loader } from '@brighterly/lib-lumee-ui'

import type { LoaderBlockProps } from '../types/interfaces'

defineOptions({
  name: 'LoaderBlock',
})

withDefaults(defineProps<LoaderBlockProps>(), {
  size: 'lg',
})
</script>

<template>
  <div class="loader-block">
    <Loader
      view="brand"
      :size="size"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_loader-block.scss" />
